import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — text/password field with a show/hide toggle.
 * Styled for both the auth forms (.pxl-field) and the px design system
 * (.px-input) via the shared .px-passwrap/.px-passbtn classes.
 */
const PasswordInput = React.forwardRef(({ id, className, ...props }, ref) => {
    const [show, setShow] = useState(false);
    return (
        <div className="px-passwrap">
            <input
                ref={ref}
                id={id}
                type={show ? "text" : "password"}
                className={className}
                {...props}
            />
            <button
                type="button"
                className="px-passbtn"
                onClick={() => setShow((s) => !s)}
                aria-label={show ? "Hide password" : "Show password"}
                aria-pressed={show}
                tabIndex={-1}
            >
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
});
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
